import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Link from '@mui/material/Link';
import { StyledTableContainer, ExcursionTypeChip } from '#component/reports/styles';
import { formatLimits, formatValue, getExcursionTypeLabel } from './helper';
import { momentFormat } from '#helper';

const ExcursionList = ({ excursions }) => {
  const account = useSelector(s => s.account, shallowEqual);

  if (!excursions?.length) {
    return null;
  }

  return (
    <StyledTableContainer>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>Timestamp</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Device</TableCell>
            <TableCell>Alert</TableCell>
            <TableCell>Limits</TableCell>
            <TableCell>Value</TableCell>
            <TableCell>Link</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {excursions.map(exc => (
            <TableRow key={exc.id}>
              <TableCell>
                {momentFormat(exc.timestamp, account, 'dateTimePartial')}
              </TableCell>
              <TableCell>
                <ExcursionTypeChip type={exc.excursionType}>
                  {getExcursionTypeLabel(exc.excursionType)}
                </ExcursionTypeChip>
              </TableCell>
              <TableCell>{exc.deviceLabel || '-'}</TableCell>
              <TableCell>{exc.alertLabel || '-'}</TableCell>
              <TableCell>
                {formatLimits(exc.excursionType, exc.alertLimits)}
              </TableCell>
              <TableCell>
                {formatValue(exc.excursionType, exc.value, exc.min, exc.max)}
              </TableCell>
              <TableCell>
                {/* TODO: replace with selected date range link */}
                <Link
                  href={`/warehouse/appliance-overview/${exc.applianceId}`}
                  target="_blank"
                  rel="noopener"
                >
                  View
                </Link>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </StyledTableContainer>
  );
};

export default ExcursionList;
